import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import httpRequest from "src/helpers/httpRequest";
import { convertToKebabCase } from "src/helpers/helperFunctions";
import { pharmaCategoryTypes } from "src/types/GlobalInterfaces";

interface IProps {
  searchApply: (val: string) => void;
  counts: {
    mainCategories: number;
    subCategories: number;
    childCategories: number;
  };
}

interface tabObject {
  label: string;
  url: string;
  count: number;
}

const PharmaCategoryHeader: React.FC<IProps> = ({
  searchApply = () => {},
  counts = { mainCategories: 0, subCategories: 0, childCategories: 0 },
}) => {
  const { pathname } = useLocation();
  const navigation = useNavigate();
  const tabList: tabObject[] = [
    {
      label: "Main Categories",
      url: "/admin/pharmacy/main-categories",
      count: counts.mainCategories,
    },
    {
      label: "Sub Categories",
      url: "/admin/pharmacy/sub-categories",
      count: counts.subCategories,
    },
    {
      label: "Child Categories",
      url: "/admin/pharmacy/child-categories",
      count: counts.childCategories,
    },
  ];

  const fetchCount = async () => {
    // const { res, err } = await httpRequest({ path: "/main-category/getTotal" });
    // if (res) {
    //     console.log("RESPONSE", res);
    // } else {
    //     console.log("ERROR", err);
    // }
  };

  useEffect(() => {
    fetchCount();
  }, []);

  return (
    <>
      <div className="mb-3 flex items-center justify-between">
        <div className="products-tabs-btn">
          {tabList.map((v: tabObject) => (
            <button
              key={v.url}
              id={`category-tab-${convertToKebabCase(v.label)}`}
              className={`font-size-15px font-Poppins-Medium ${
                pathname === v.url && "active"
              }`}
              onClick={() => navigation(v.url)}
            >
              {v.label} ({v.count})
            </button>
          ))}
        </div>
        <SearchFilterInput
          inputExtraStyle={{ marginBottom: 0 }}
          onChangeText={searchApply}
          searchId="search-input"
        />
      </div>
      <hr className="mb-3" style={{ border: "1px solid #D4D4D4" }} />
    </>
  );
};

export default PharmaCategoryHeader;
